import {
  CustomerDefinedFieldDefinition,
  CustomerDefinedFieldDefinitionSourcePath,
  CustomerDefinedFieldValue
} from '@ui/shared/model';

export interface SplitCustomerDefinedFields<T> {
  freeTextFields: T[];
  regularFields: T[];
}

/**
 * Splits customer defined field definitions by source path
 * @param fields Array of CustomerDefinedFieldDefinition
 * @returns Object containing freeTextFields and regularFields arrays
 */
export function splitCustomerDefinedFieldDefinitions(
  fields: CustomerDefinedFieldDefinition[]
): SplitCustomerDefinedFields<CustomerDefinedFieldDefinition> {
  return fields.reduce<
    SplitCustomerDefinedFields<CustomerDefinedFieldDefinition>
  >(
    (acc, field) => {
      if (
        field.sourcePath ===
          CustomerDefinedFieldDefinitionSourcePath.FREITEXTE ||
        field.sourcePath === CustomerDefinedFieldDefinitionSourcePath.IMMOBILIE
      ) {
        acc.freeTextFields.push(field);
      } else {
        acc.regularFields.push(field);
      }
      return acc;
    },
    {
      freeTextFields: [],
      regularFields: []
    }
  );
}

/**
 * Splits customer defined field values by source path
 * @param values Array of CustomerDefinedFieldValue
 * @returns Object containing freeTextFields and regularFields arrays
 */
export function splitCustomerDefinedFieldValues(
  values: CustomerDefinedFieldValue[]
): SplitCustomerDefinedFields<CustomerDefinedFieldValue> {
  return values.reduce<SplitCustomerDefinedFields<CustomerDefinedFieldValue>>(
    (acc, field) => {
      if (
        field.definition.sourcePath ===
          CustomerDefinedFieldDefinitionSourcePath.FREITEXTE ||
        field.definition.sourcePath ===
          CustomerDefinedFieldDefinitionSourcePath.IMMOBILIE
      ) {
        acc.freeTextFields.push(field);
      } else {
        acc.regularFields.push(field);
      }
      return acc;
    },
    {
      freeTextFields: [],
      regularFields: []
    }
  );
}
